import React, { useState } from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Divider, Grid, Button } from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '@semi-configurator-messages'
import { priceFormatter } from '../../../../Configurators/utils/PriceFormatter'
import { ProductDetails, configContext } from '../Sirna'
import { useSirnaAddToCartMutation } from '@src/mutations/SemiconfigSirnaMutation.generated'
//import { QUICK_CART } from '../../../../../queries/QuickCartQuery'
import AddToCartItems from '@src/routes/Configurators/components/AddToCart/AddToCartItems'
import { loginRoute, useRouter } from '@src/routes'
import {
  SnackbarType,
  useGlobalSnackbar,
} from '@src/components/GlobalSnackbar/globalSnackBarContext'
import {
  SemiConfigProperties,
  ErrorMessage,
  ActiveLinkType,
  Url,
  SiRNAProperties,
} from '../enum'
import CircleLoader from '@src/components/CircleLoader'
import {
  ProductNames,
  ConfiguratorValues,
} from '@src/routes/Configurators/utils/constants'
import {
  handleGAAddToCartForConfigurator,
  handleGAAddToCartErrorsForConfigurator,
} from '@utils/analytics/configuratorAnalytics'
import { getSemiConfiguratorGAdata } from '@src/routes/SemiConfigurators/utils/util'
import RequestQuotationPopup from './RequestQuotationPopup'

const useStyles = makeStyles((theme: Theme) => ({
  contentWrapper: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(5),
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(5),
  },
  note: {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.pxToRem(12),
    paddingBottom: theme.spacing(0),
    paddingRight: theme.spacing(1),
  },
  list: {
    padding: theme.spacing(0, 0, 10, 0),
  },
  head: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: theme.typography.fontWeightBold,
    margin: theme.spacing(0, 0, 5),
  },
  button: {
    marginTop: theme.spacing(0),
    minWidth: '100%',
  },
  listPadding: {
    paddingLeft: theme.spacing(5),
    paddingTop: theme.spacing(2),
    fontSize: theme.typography.pxToRem(12),
  },
  subListPadding: {
    paddingBottom: theme.spacing(2),
  },
  subHead: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: theme.typography.fontWeightMedium,
    margin: theme.spacing(3, 0, 4),
  },
  subPrice: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: theme.typography.fontWeightMedium,
    margin: theme.spacing(3, 0, 4),
    textAlign: 'right',
  },
  headingPadding: {
    marginTop: theme.spacing(-0.5),
    marginLeft: theme.spacing(-1),
  },
  dividerHor: {
    marginTop: theme.spacing(-3),
  },
  leftPadding: {
    marginLeft: theme.spacing(112.5),
  },
  subTotal: {
    fontSize: theme.typography.pxToRem(12),
  },
  fontQuote: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightBold,
  },
  marginBottom: {
    marginBottom: theme.spacing(5),
  },
}))

interface SummarySirnaProps {
  onDelete: any
  productDetails: ProductDetails
  currencyFormat: string
  updateError: any
  thousandSeparator: any
  thousandSpacing: any
  prefixCurrecny: any
  decimalSeparator: any
}
export interface SemiconfigDetailsForGA {
  productDetails: any
  totalQuantity: number
  price: string
  productName: string
}

const SummarySirna: React.FC<SummarySirnaProps> = (props) => {
  const classes = useStyles()
  const intl = useIntl()
  const { state, dispatch } = React.useContext(configContext)
  const { selectedData } = state
  const [price, setPrice] = useState<string>('')
  const [totalItem, setTotalItem] = useState<number>(0)
  const router = useRouter()
  const { setGlobalSnackbarState } = useGlobalSnackbar()
  const [totalPrice, setTotalPrice] = useState<string>('')
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [quoteDialogOpen, setQuoteDialogOpen] = React.useState(false)
  const locale = props.productDetails.locale
  const {
    currencyFormat,
    thousandSeparator,
    thousandSpacing,
    prefixCurrecny,
    decimalSeparator,
  } = props

  React.useEffect(() => {
    const sapNextEnabled = props.productDetails.sapNextEnabled
    const timeZone = props.productDetails.timeZone
    const store = props.productDetails.store
    dispatch({
      type: 'UPDATE_ADD_TO_CART_DATA',
      data: {
        ...state.sirnaAddtoCartData,
        sapNextEnabled,
        locale,
        timeZone,
        store,
      },
    })
    // TODO: need a test before we refactor these dependencies
  }, [])

  const [sirnaAddToCart, { data, loading }] = useSirnaAddToCartMutation({
    // refetchQueries: [
    //   {
    //     query: QUICK_CART,
    //     variables: { id: CartRequestAction.Mini },
    //   },
    // ],
    // awaitRefetchQueries: true,
  })

  const calculatePrice = (): void => {
    let price = 0
    let isPriceValid = true
    if (selectedData) {
      const selectedSubSetList: any[] = []
      selectedData?.forEach((item: any) => {
        selectedSubSetList.push(...item.subSetInfo)
      })
      selectedSubSetList.forEach((item) => {
        if (
          item.count > 0 &&
          item.price &&
          item.price !== SemiConfigProperties.Quote &&
          item.price !== '--'
        ) {
          price = price + parseFloat(item.price)
        } else if (item.price === SemiConfigProperties.Quote) {
          setPrice(intl.formatMessage(messages._PC_QUOTE_ITEM))
          isPriceValid = false
        } else {
          setPrice('--')
          isPriceValid = false
        }
      })
      if (price !== null && isPriceValid) {
        const formattedPrice = priceFormatter(
          price,
          currencyFormat,
          thousandSeparator,
          thousandSpacing,
          decimalSeparator,
          prefixCurrecny,
          selectedSubSetList[0]?.currencySymbol
        )
        const subtotal = formattedPrice
        setPrice(subtotal)
        setTotalPrice(subtotal)
      }
    }
  }

  React.useEffect(() => {
    if (selectedData && selectedData.length > 0) {
      calculatePrice()
    }
    // TODO: need a test before we refactor these dependencies
  }, [selectedData, props.onDelete])

  //configuring the Configurator product data for sending it to GA
  const itemName = ProductNames['sirna']
  const configProductDetails: SemiconfigDetailsForGA =
    getSemiConfiguratorGAdata(
      state.selectedData,
      itemName,
      locale,
      props.currencyFormat,
      false
    )

  const handleAddToCart = async (): Promise<void> => {
    if (props.productDetails.countryCode === SiRNAProperties.China) {
      setQuoteDialogOpen(true)
    } else {
      let itemCount = 0
      if (state.selectedData?.length) {
        const subList = state.selectedData.map((item) => item?.subSetInfo)
        itemCount = subList.flat().length
      }
      setTotalItem(itemCount)

      const selectedSubSetList: any[] = []
      selectedData?.forEach((item: any) => {
        selectedSubSetList.push(...item.subSetInfo)
      })

      const sirnaAddtoCartFinalData = {
        ...state.sirnaAddtoCartData,
        results: selectedSubSetList.map((item: any) => {
          return {
            siRNAId: item.siRNAId?.toString(),
            geneId: item.geneId?.toString(),
            geneSymbol: item.geneSymbol?.toString(),
            refseqId: item.refseqId?.toString(),
            species: item.species?.toString(),
            method: item.method?.toString(),
            sirnaProdType: item.sirnaProdType?.toString(),
            siRNAType: item.siRNAType?.toString(),
            siRNAAntiSenseSeq: item.siRNAAntiSenseSeq?.toString(),
            siRNASenseSeq: item.siRNASenseSeq?.toString(),
            fuzzyStart: item.fuzzyStart?.toString(),
            siRNATargetSeq: item.siRNATargetSeq?.toString(),
            fuzzyEnd: item.fuzzyEnd?.toString(),
            ranking: item.ranking?.toString(),
            refseqStart: item.refseqStart?.toString(),
            refseqEnd: item.refseqEnd?.toString(),
            purification: item.purification?.toString(),
            size: item.size?.toString(),
          }
        }),
        country: props.productDetails.region,
        sapNextEnabled: props.productDetails.sapNextEnabled,
        locale: props.productDetails.locale,
        timeZone: props.productDetails.timeZone,
        store: props.productDetails.store,
        participantId: props.productDetails.participantId,
      }

      await sirnaAddToCart({
        variables: { input: sirnaAddtoCartFinalData },
        fetchPolicy: 'no-cache',
      })
    }
  }

  React.useEffect(() => {
    if (data) {
      const errorMessage = ConfiguratorValues.AddToCartFail
      if (data?.sirnaAddToCart?.serverError) {
        props.updateError(ConfiguratorValues.AddToCartFail)
        // GAtracking event on button click of addToCart
        handleGAAddToCartErrorsForConfigurator(
          configProductDetails,
          errorMessage
        )
      } else {
        if (data?.sirnaAddToCart?.result === SemiConfigProperties.Success) {
          // GAtracking event on button click of addToCart
          handleGAAddToCartForConfigurator(configProductDetails)
          setTotalPrice(price)
          setDialogOpen(true)
        } else if (
          data?.sirnaAddToCart?.result === ErrorMessage.AccessTokenExpire
        ) {
          router.push(loginRoute.index())
          setGlobalSnackbarState({
            open: true,
            message: (
              <FormattedMessage
                {...messages.USER_NOT_AUTHORIZED_OR_TOKEN_EXPIRED}
              />
            ),
            variant: SnackbarType.Error,
          })
        } else {
          props.updateError(ConfiguratorValues.AddToCartFail)
          handleGAAddToCartErrorsForConfigurator(
            configProductDetails,
            errorMessage
          )
        }
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [data])

  return (
    <div className={classes.contentWrapper}>
      <Grid container>
        <Grid item sm={6} className={classes.leftPadding}>
          <Grid className={classes.head}>
            {<FormattedMessage {...messages.CART_SUMMARY} />}
          </Grid>
          <Divider className={classes.dividerHor} />
          <Grid container>
            <Grid item sm={6} className={classes.subHead}>
              {
                <FormattedMessage
                  id="CART_SUBTOTAL"
                  defaultMessage="Subtotal"
                />
              }
              :
            </Grid>
            <Grid item sm={6} className={classes.subPrice}>
              {price}
            </Grid>
          </Grid>
          <Grid container direction="row" className={classes.list} spacing={2}>
            {price === intl.formatMessage(messages._PC_QUOTE_ITEM) ? (
              <Grid item sm={12} className={classes.fontQuote}>
                <FormattedMessage {...messages.CART_QUOTATION_TEXT} />
              </Grid>
            ) : (
              <>
                <Grid item sm={1} className={classes.note}>
                  {
                    <FormattedMessage
                      id="CART_ITEM_NOTE"
                      defaultMessage="Note"
                    />
                  }
                  :
                </Grid>
                <Grid item sm={11} className={classes.subTotal}>
                  {<FormattedMessage {...messages.CONF_PRICE_SUB_TOTAL} />}
                </Grid>
              </>
            )}
            <Grid container spacing={3}>
              <Grid className={classes.listPadding}>
                <li className={classes.subListPadding}>
                  {
                    <FormattedMessage
                      {...messages.CONF_APPLICATIONFREIGHT_TAX}
                    />
                  }
                </li>
                <li>
                  {<FormattedMessage {...messages.CONF_PROMOTIONAL_CODES} />}
                </li>
              </Grid>
            </Grid>
          </Grid>

          <Grid item sm={12}>
            <Button
              className={classes.button}
              color="primary"
              variant="contained"
              size="medium"
              onClick={handleAddToCart}
            >
              {props.productDetails.countryCode === SiRNAProperties.China ? (
                <FormattedMessage {...messages.REQUEST_QUOTATION} />
              ) : (
                <FormattedMessage
                  id="ADD_TO_CART"
                  defaultMessage="Add to Cart"
                />
              )}
            </Button>
          </Grid>
          <Grid container>
            <Grid item sm={6}>
              <AddToCartItems
                dialogOpen={dialogOpen}
                setDialogOpen={setDialogOpen}
                price={totalPrice}
                totalItem={totalItem}
                companionProducts={null}
                productType={ActiveLinkType.ProductName}
                urlProduct={Url.SequenceUrl}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item>
              <RequestQuotationPopup
                dialogOpen={quoteDialogOpen}
                setDialogOpen={setQuoteDialogOpen}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {loading && <CircleLoader />}
    </div>
  )
}

export default SummarySirna
